import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';

import * as Yup from 'yup';
import Modal from '../../../ui/Modal';

import { useContext } from '../Context';

import {
  Form as BaseForm,
  TextField,
  FileField,
  CheckBoxField,
  CancelPopupButton,
  SubmitButton,
} from '../../../../ui/FormElement';

export default function CreateModal({ show, onHide }) {
  const { dispatch, actions, state } = useContext();

  const FormSchema = Yup.object().shape({
    title: Yup.string().required('required'),
    file: Yup.mixed()
      .required('required')
      .test(
        'fileSize',
        'The file size exceeds the limit allowed: 10Mb',
        (value) => value && value.size < 10 * 1024 * 1024,
      ),
  });

  const [loader, setLoader] = useState(false);

  const [formData, setFormData] = useState({
    title: '',
    file: undefined,
    terms_and_conditions: true,
  });

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    setSubmitting(false);
    setLoader(true);
    actions.createDocument(
      dispatch,
      state.enterpriseId,
      values,
      () => {
        setLoader(false);
        onHide();
        actions.load(dispatch, state.enterpriseId);
      },
      (errorData) => {
        const newErrors = {};
        errorData.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setLoader(false);
      },
    );
  };

  return (
    <Modal show={show} onHide={onHide} header="Upload Policy Documents">
      <BaseForm
        enableReinitialize
        validationSchema={FormSchema}
        initialValues={formData}
        onSubmit={onSubmit}
      >
        <div>
          <TextField
            name="title"
            label={(
              <>
                <span>File Name</span>
                <abbr title="required">*</abbr>
              </>
              )}
          />
        </div>
        <div>
          <FileField
            name="file"
            label={(
              <>
                <span>File</span>
                <abbr title="required">*</abbr>
              </>
              )}
          />
        </div>
        <div>
          <CheckBoxField
            name="terms_and_conditions"
            inline
            label={(
              <span>Executed Terms and Conditions document</span>
                    )}
          />
        </div>
        <div className="mt50 mb30">
          <Row>
            <Col md={6}>
              <CancelPopupButton
                className="btn btn-primary btn-outline mr5 ml5 width-120"
                title="Cancel"
                onClick={() => onHide()}
              />
            </Col>
            <Col md={6} className="text-right">
              <SubmitButton
                title={`${loader ? 'Uploading ...' : 'Save'}`}
                className={`btn width-120 btn-primary submit-button mr5 ml5 ${
                  loader ? 'not-possible-click' : ''
                }`}
              />
            </Col>
          </Row>
        </div>
      </BaseForm>
    </Modal>
  );
}
